/* Bambaw Impact page (V6) — shared behaviour for impact-* sections.
   Safe to include multiple times; initialises once and re-binds on theme-editor reloads. */
(function () {
  if (window.__bambawImpact) return;
  window.__bambawImpact = true;
  document.documentElement.classList.add('imp-js');

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var mobile = window.matchMedia('(max-width: 749px)');
  var touch = window.matchMedia('(hover: none)');
  var editor = !!(window.Shopify && window.Shopify.designMode);
  function $$(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
  function once(el, key) { if (el.dataset['impB' + key]) return false; el.dataset['impB' + key] = '1'; return true; }

  /* ---------- Fade-in on scroll ---------- */
  var fadeIO = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); fadeIO.unobserve(e.target); } });
  }, { threshold: 0.15 });
  function initFade(root) {
    $$(root, '.imp-fade').forEach(function (el) {
      if (!once(el, 'f')) return;
      if (editor || reduce.matches) el.classList.add('in'); else fadeIO.observe(el);
    });
  }

  /* ---------- Background videos: lazy-load, play only while visible ---------- */
  function loadVideo(v) {
    if (v._impLoaded) return;
    v._impLoaded = true;
    $$(v, 'source[data-src]').forEach(function (s) { s.src = s.getAttribute('data-src'); });
    v.load();
    v.addEventListener('playing', function () { v.classList.add('is-playing'); });
  }
  function canPlay(v) { return !reduce.matches && !(mobile.matches && v.hasAttribute('data-desktop-only')); }
  var videoIO = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      var v = e.target;
      if (e.isIntersecting) {
        if (!canPlay(v)) return;
        loadVideo(v);
        var p = v.play(); if (p && p.catch) p.catch(function () {});
      } else if (!v.paused) v.pause();
    });
  }, { rootMargin: '200px 0px' });
  function initVideos(root) {
    $$(root, 'video[data-imp-video]').forEach(function (v) { if (once(v, 'v')) videoIO.observe(v); });
  }

  /* ---------- Hover cards: tap (touch) or Enter/Space (keyboard) to open ---------- */
  function initCards(root) {
    $$(root, '.imp-card, .imp-tile').forEach(function (c) {
      if (!once(c, 'c')) return;
      c.addEventListener('click', function (e) {
        if (e.target.closest('a')) return;
        if (touch.matches) c.classList.toggle('open');
      });
      c.addEventListener('keydown', function (e) {
        if (e.target !== c) return;
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); c.classList.toggle('open'); }
      });
    });
  }

  /* ---------- Materials slider ---------- */
  function initSliders(root) {
    $$(root, '[data-imp-slider]').forEach(function (sec) {
      if (!once(sec, 's')) return;
      var s = sec.querySelector('.imp-slider');
      if (!s) return;
      var slides = $$(s, '.imp-slide');
      var prev = sec.querySelector('[data-imp-prev]'), next = sec.querySelector('[data-imp-next]'), cnt = sec.querySelector('[data-imp-count]');
      function step() { return slides.length ? slides[0].offsetWidth + 15 : s.clientWidth; }
      function pad(n) { return String(n).padStart(2, '0'); }
      function upd() {
        var max = s.scrollWidth - s.clientWidth;
        /* all tiles visible (e.g. 4 on desktop): hide the arrows and counter */
        sec.classList.toggle('imp-slider-fits', max <= 2);
        var i = Math.round(s.scrollLeft / step());
        if (cnt) cnt.textContent = pad(Math.min(i + 1, slides.length)) + ' / ' + pad(slides.length);
        if (prev) prev.disabled = s.scrollLeft <= 2;
        if (next) next.disabled = s.scrollLeft >= max - 2;
      }
      function go(dir) { s.scrollBy({ left: dir * step(), behavior: reduce.matches ? 'auto' : 'smooth' }); }
      prev && prev.addEventListener('click', function () { go(-1); });
      next && next.addEventListener('click', function () { go(1); });
      s.addEventListener('scroll', function () { requestAnimationFrame(upd); }, { passive: true });
      s.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); go(1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); go(-1); }
      });
      /* mouse drag on desktop */
      var down = false, sx = 0, sl = 0, moved = false;
      s.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        down = true; moved = false; sx = e.clientX; sl = s.scrollLeft;
      });
      window.addEventListener('pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - sx;
        if (Math.abs(dx) > 5) { moved = true; s.classList.add('is-dragging'); }
        if (moved) s.scrollLeft = sl - dx;
      });
      window.addEventListener('pointerup', function () {
        if (!down) return; down = false;
        if (moved) { s.classList.remove('is-dragging'); var st = step(); s.scrollTo({ left: Math.round(s.scrollLeft / st) * st, behavior: 'smooth' }); }
      });
      s.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
      s.addEventListener('dragstart', function (e) { e.preventDefault(); });
      window.addEventListener('resize', upd);
      upd();
      sec._impGoTo = function (el) { s.scrollTo({ left: el.offsetLeft - s.offsetLeft, behavior: 'smooth' }); };
    });
  }

  /* ---------- Hero menu: docks after the hero, highlights the section in view ---------- */
  var navs = [];
  function initNav(root) {
    $$(root, '[data-imp-nav]').forEach(function (nav) {
      if (!once(nav, 'n')) return;
      var hero = nav.closest('.imp-hero');
      var links = $$(nav, 'a[href^="#"]');
      /* Placeholder so the menu can move to <body> while docked and come back after.
         Themes often put a transform on section wrappers (scroll animations), which
         would trap position:fixed inside the hero; living in <body> avoids that. */
      var mark = document.createComment('imp-nav');
      nav.parentNode.insertBefore(mark, nav);
      var item = { nav: nav, hero: hero, links: links, mark: mark };
      navs = navs.filter(function (n) {
        if (document.contains(n.mark)) return true;
        if (n.nav.parentNode === document.body) n.nav.remove(); /* hero was reloaded in the theme editor */
        return false;
      });
      navs.push(item);
      links.forEach(function (a) {
        a.addEventListener('click', function (e) {
          var t = document.getElementById(a.getAttribute('href').slice(1));
          if (!t) return;
          e.preventDefault();
          t.scrollIntoView({ behavior: reduce.matches ? 'auto' : 'smooth', block: 'start' });
          if (history.replaceState) history.replaceState(null, '', a.getAttribute('href'));
        });
      });
      /* mobile: one-time nudge to show the row scrolls sideways */
      if (window.matchMedia('(max-width:1100px)').matches && !reduce.matches && !editor) {
        var touched = false;
        ['touchstart', 'wheel', 'pointerdown'].forEach(function (ev) { nav.addEventListener(ev, function () { touched = true; }, { passive: true }); });
        setTimeout(function () {
          if (touched || nav.classList.contains('is-docked') || nav.scrollWidth <= nav.clientWidth + 10 || nav.scrollLeft > 0) return;
          nav.scrollTo({ left: 70, behavior: 'smooth' });
          setTimeout(function () { if (!touched) nav.scrollTo({ left: 0, behavior: 'smooth' }); }, 750);
        }, 1400);
      }
    });
  }
  function updateNavs() {
    var line = window.innerHeight * 0.4;
    navs.forEach(function (n) {
      if (!document.contains(n.mark)) { if (n.nav.parentNode === document.body) n.nav.remove(); return; }
      var heroBottom = n.hero ? n.hero.getBoundingClientRect().bottom : 0;
      var docked = heroBottom < 40;
      if (docked && n.nav.parentNode !== document.body) document.body.appendChild(n.nav);
      else if (!docked && n.nav.parentNode === document.body) n.mark.parentNode.insertBefore(n.nav, n.mark.nextSibling);
      n.nav.classList.toggle('is-docked', docked);
      var idx = 0;
      n.links.forEach(function (a, i) {
        var t = document.getElementById(a.getAttribute('href').slice(1));
        if (t && t.getBoundingClientRect().top <= line) idx = i;
      });
      n.links.forEach(function (a, i) {
        a.classList.toggle('on', i === idx);
        if (i === idx) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current');
      });
    });
    $$(document, '[data-imp-top]').forEach(function (b) {
      var hero = document.querySelector('.imp-hero');
      var h = hero ? hero.offsetHeight : window.innerHeight;
      b.classList.toggle('show', window.scrollY > h * 0.8);
    });
  }
  var ticking = false;
  function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(function () { ticking = false; updateNavs(); }); } }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);

  function initTop(root) {
    $$(root, '[data-imp-top]').forEach(function (b) {
      if (!once(b, 't')) return;
      /* fixed button: live in <body> so theme transforms can't trap it (see initNav) */
      $$(document.body, ':scope > [data-imp-top]').forEach(function (old) { if (old !== b) old.remove(); });
      if (b.parentNode !== document.body) document.body.appendChild(b);
      b.addEventListener('click', function (e) { e.preventDefault(); window.scrollTo({ top: 0, behavior: reduce.matches ? 'auto' : 'smooth' }); });
    });
  }

  function init(root) {
    root = root || document;
    initFade(root); initVideos(root); initCards(root); initSliders(root); initNav(root); initTop(root);
    onScroll();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);

  /* Theme editor support */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var t = e.target;
    var slide = t.closest && t.closest('.imp-slide');
    var sec = slide && slide.closest('[data-imp-slider]');
    if (sec && sec._impGoTo) sec._impGoTo(slide);
    var card = t.matches && t.matches('.imp-card, .imp-tile') ? t : t.querySelector && t.querySelector('.imp-card, .imp-tile');
    if (card) card.classList.add('open');
  });
  document.addEventListener('shopify:block:deselect', function (e) {
    $$(e.target, '.imp-card.open, .imp-tile.open').forEach(function (c) { c.classList.remove('open'); });
    if (e.target.classList && e.target.classList.contains('open')) e.target.classList.remove('open');
  });
})();
